/******/ (() => { // webpackBootstrap
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
$(document).ready(function () {
  $('input[type="email"]').each(function () {
    var $input = $(this);
    emailAutocomplete($input);
  });
});

/**
 * Anexa funcionalidade de autocompletar domínio de e-mail a um campo de entrada.
 *
 * @param {jQuery} $input Campo de entrada de e-mail.
 * NOTE Para minificar o arquivo rode 'gulp watchJs --fn=autocomplete --folder=autocomplete'
 */
function emailAutocomplete($input) {
  var settings = {
    domains: ['gmail.com', 'outlook.com', 'hotmail.com', 'yahoo.com', 'icloud.com'],
    maxSuggestions: 5
  };
  var listId = 'email-autocomplete-' + crypto.randomUUID();
  var $datalist = $('<datalist>').attr('id', listId);
  $input.addClass('email-autocomplete');
  $input.after($datalist);
  $input.attr('list', listId);

  // Passa os parâmetros para a função externa
  $input.on('keyup', function () {
    return updateSuggestions($input, $datalist, settings.domains, settings.maxSuggestions);
  });
}

/**
 * Atualiza as sugestões de autocompletar para um campo de e-mail.
 *
 * @param {jQuery} $input Campo de entrada do e-mail.
 * @param {jQuery} $datalist Elemento datalist associado.
 * @param {string[]} domains Lista de domínios disponíveis.
 * @param {number} maxSuggestions Número máximo de sugestões.
 */
function updateSuggestions($input, $datalist, domains, maxSuggestions) {
  var currentInputValue = $input.val();
  $datalist.empty();
  if (!currentInputValue.includes('@')) return;
  var _currentInputValue$sp = currentInputValue.split('@'),
    _currentInputValue$sp2 = _slicedToArray(_currentInputValue$sp, 2),
    username = _currentInputValue$sp2[0],
    domainFragment = _currentInputValue$sp2[1];
  var matchingDomains = domains.filter(function (domain) {
    return domain.startsWith(domainFragment);
  }).slice(0, maxSuggestions);
  matchingDomains.forEach(function (domain) {
    $('<option>').val("".concat(username, "@").concat(domain)).appendTo($datalist);
  });
}
/******/ })()
;